import styles from './base.module.scss'

export const RootComponent: React.FC = ({ children }) => <div className={styles.root}>{children}</div>
